import React from "react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import Themes from "themes";
import { createRoot } from "react-dom/client";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
	<BrowserRouter basename={baseUrl}>
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={Themes.default}>
				<App />
			</ThemeProvider>
		</StyledEngineProvider>
	</BrowserRouter>
);

//Not using this as workbox is load from google CDN <- not allowed under CSP
//registerServiceWorker();
